import { render, staticRenderFns } from "./contact_us.vue?vue&type=template&id=195ce112"
import script from "./contact_us.vue?vue&type=script&lang=js"
export * from "./contact_us.vue?vue&type=script&lang=js"
import style0 from "./contact_us.vue?vue&type=style&index=0&id=195ce112&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports